import SportsGolfRoundedIcon from "@mui/icons-material/SportsGolfRounded";
import SportsEsportsRoundedIcon from "@mui/icons-material/SportsEsportsRounded";
import MenuBookRoundedIcon from "@mui/icons-material/MenuBookRounded";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import { useNavigate } from "react-router-dom";

import { userState } from "../../interface/MainInterface";
import { HttpMainApi } from "../../interface/main-api";

interface Props {
  userState: userState;
  currentItem?: "reservation" | "book-scan";
}

const mainApi = new HttpMainApi();
const menuItems = [
  { key: "reservation", label: "골프 예약", path: "/reservationscreen", icon: SportsGolfRoundedIcon },
  { key: "book-cafe", label: "북카페 예약", path: "/reservationbookcafe/reserve", icon: SportsEsportsRoundedIcon },
  { key: "book-scan", label: "대여·반납", path: "/mobilebookscan", icon: MenuBookRoundedIcon },
  { key: "account", label: "정산", path: "/reservationaccount", icon: ReceiptLongRoundedIcon },
] as const;

const MobileMainFooter = ({ userState, currentItem }: Props) => {
  const navigate = useNavigate();

  return (
    <nav className="hpoint-renewal hp-mobile-home__footer" aria-label="모바일 메인 메뉴">
      {menuItems.map(({ key, label, path, icon: Icon }) => (
        <button
          key={key}
          className={`hp-mobile-home__footer-item${currentItem === key ? " hp-mobile-home__footer-item--active" : ""}`}
          type="button"
          aria-current={currentItem === key ? "page" : undefined}
          onClick={() => {
            if (key === "book-cafe") {
              try {
                void mainApi.put_dashboard_event({
                  eventType: "BOOK_CAFE_MENU_CLICK",
                  userId: userState.userId,
                  userName: userState.userName,
                  userDong: userState.userDong,
                  userHo: userState.userHo,
                  path,
                  source: "MOBILE_MAIN",
                }).catch(() => undefined);
              } catch {
                // Logging must never block navigation.
              }
            }
            navigate(path);
          }}
        >
          <Icon className="hp-mobile-home__footer-icon hp-mobile-home__footer-icon--filled" aria-hidden="true" />
          <span>{label}</span>
        </button>
      ))}
    </nav>
  );
};

export default MobileMainFooter;
